import React from 'react'
import TextField from '@material-ui/core/TextField'
import { useController } from 'react-hook-form'
import withStyles from '@material-ui/styles/withStyles'

const styles = (theme) => ({
  inputLabel: {
    transform: 'translate(0, 0) !important',
    marginTop: theme.spacing(3)
  }
})

const TextFieldComponent = ({
  classes,
  name,
  control,
  defaultValue = '',
  label,
  className,
  disabled,
  disableUnderline = false,
  labelStyle,
  helperTextStyle,
  inputComponent,
  setIsFocused,
  onChangeOverride,
  onChange,
  displayValue,
  multiline,
  placeholder,
  onMouseLeave,
  inputMaxLength,
  inputMax,
  inputMin,
  type,
  ...rest
}) => {
  const { field, fieldState } = useController({
    name,
    control,
    defaultValue: defaultValue
  })

  const { invalid, error } = fieldState

  const [isFocused, _setIsFocused] = React.useState(false)

  const handleFocus = () => {
    _setIsFocused(true)
  }

  const handleBlur = (e) => {
    field.onBlur(e)
    _setIsFocused(false)
  }

  const handleChange = (e) => {
    if (typeof onChangeOverride === 'function') {
      onChangeOverride(e, field, fieldState)
    } else {
      onChange?.(e)
      field.onChange(e)
    }
  }

  React.useEffect(() => {
    if (setIsFocused) {
      setIsFocused(isFocused)
    }
  }, [isFocused, setIsFocused])

  return (
    <TextField
      type={type}
      onMouseLeave={onMouseLeave}
      {...field}
      value={
        typeof displayValue === 'function'
          ? displayValue()
          : displayValue ?? field.value
      }
      onChange={handleChange}
      label={label}
      placeholder={isFocused ? placeholder : undefined}
      error={invalid}
      helperText={invalid && error}
      disabled={disabled}
      onFocus={handleFocus}
      onBlur={handleBlur}
      multiline={multiline}
      InputProps={{
        classes: {
          input: className
        },
        disableUnderline: disableUnderline,
        inputComponent: inputComponent
      }}
      InputLabelProps={{
        shrink: true,
        style: {
          fontSize: '15px',
          ...labelStyle
        },
        classes: {
          shrink: classes.inputLabel
        }
      }}
      inputProps={{
        'aria-label': label,
        maxLength: inputMaxLength,
        min: inputMin,
        max: inputMax
      }}
      FormHelperTextProps={{
        style: {
          ...helperTextStyle
        }
      }}
      {...rest}
    />
  )
}

export const HookTextField = withStyles(styles)(TextFieldComponent)
